import { createSelector } from '@ngrx/store';
import { IRootState } from '../../../root';
import { IPurposeState } from './purpose.state';

export class PurposeSelectors {
  // todo: replace any type state with root state (once defined)
  static readonly purposeState = (state: IRootState): IPurposeState => {
    return state.purpose as IPurposeState;
  };

  static readonly model = createSelector(PurposeSelectors.purposeState, (purpose: IPurposeState) => {
    return purpose.model;
  });

  static readonly data = createSelector(PurposeSelectors.purposeState, (purpose: IPurposeState) => {
    return purpose.data;
  });
}
